const PREFIX = '/v1/base/verifyService'

export const URL = {
  PIC_CODE: PREFIX + '/getCaptchaVerify',
  SMS_CODE: PREFIX + '/getSmsVerify',
  LOGIN_SMS_CODE: PREFIX + '/getLoginSmsVerify',
  LOGIN_EMAIL_CODE: PREFIX + '/getLoginEmailVerify',
  REGISTER_SMS_CODE: PREFIX + '/getRegSmsVerify',
  REGISTER_EMAIL_CODE: PREFIX + '/getRegEmailVerify',
  EDIT_EMAIL_CODE: PREFIX + '/getEditEmailVerify',
  EDIT_PHONE_CODE: PREFIX + '/getEditPhoneVerify'
}
